import './Functions/invitationTrial';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
// Shared styles also keep prerendered documents readable before React loads.
import './Components/FrontPage/Frontpage.css';
import RouteEntry from './RouteEntry';
import { getStatsEntry } from './seo/statsEntry';
import { getPlansEntry } from './seo/plansEntry';
import { prepareStatsMetadata } from './seo/statsMetadata';
import { initializeAnalytics } from './Functions/ga4';
import { resolveAnalyticsExemption } from './Functions/analyticsExemption';

// Ask the API whether this visitor's IP is analytics-exempt (owner/dev
// machines) before any tag can load. Fails open after a short timeout, so
// regular visitors are never delayed more than the existing tag deferral.
const rootElement = document.getElementById('root');
const statsEntry = getStatsEntry(
  window.location.pathname,
  navigator.userAgent,
  rootElement.querySelector('[data-seo-route]')?.getAttribute('data-seo-route')
);

const plansEntry = getPlansEntry(
  window.location.pathname,
  navigator.userAgent,
  rootElement.querySelector('[data-seo-route]')?.getAttribute('data-seo-route')
);

const deferAnalyticsBootstrap = () => {
  if (typeof window === 'undefined') return;
  let done = false;
  const interactionEvents = ['pointerdown', 'keydown', 'touchstart', 'scroll'];
  const run = () => {
    if (done) return;
    done = true;
    interactionEvents.forEach((name) => {
      window.removeEventListener(name, run, { capture: true });
    });
    try {
      initializeAnalytics();
    } catch {}
  };

  // The tag scripts (gtag + pixel, ~480 KiB) stay off the LCP-critical
  // window on slow devices: load on first interaction, or shortly after the
  // page finishes loading. Bounces that never reach either point still get
  // their page_view through the first-party relay's pagehide beacon.
  interactionEvents.forEach((name) => {
    window.addEventListener(name, run, { capture: true, passive: true, once: true });
  });
  const armLoadFallback = () => window.setTimeout(run, 3500);
  if (document.readyState === 'complete') {
    armLoadFallback();
  } else {
    window.addEventListener('load', armLoadFallback, { once: true });
  }
  // Absolute fallback in case the load event is held up by a straggler asset.
  window.setTimeout(run, 12000);
};

if (!statsEntry.keepStatic && !plansEntry.keepStatic) {
  resolveAnalyticsExemption();
  deferAnalyticsBootstrap();
  const statsPage = statsEntry.page ? prepareStatsMetadata(statsEntry.page, document) : null;
  if (plansEntry.page) prepareStatsMetadata(plansEntry.page, document);
  const staticHtml = rootElement.innerHTML;
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <RouteEntry statsPage={statsPage} staticHtml={staticHtml} />
    </React.StrictMode>
  );
}
